const SidebarElementConstants = {
  ELEMENT_TYPES: {
    REFERENCE: "reference",
    GROUP: "group",
  },

  REF_TYPES: {
    ITEM: "item",
    DOC: "doc",
    SUBSPACE: "subspace",
    LINK: "link",
  },
};

export default SidebarElementConstants;
